<template>
	<div class="games-filter-section">
		<a class="games-filter-btn all" :class="{ active: selectedFilter === 'all' }" @click="setFilter('all', 'All Games')">
			<svgIcon icon-holder-class="icon-btn-all" icon-id="icon-btn-all" />
			<span class="filter-btn-text">{{ $t('navigation.allGames') }}</span>
		</a>
		<a
			v-if="games.pc.length > 0"
			class="games-filter-btn windows"
			:class="{ active: selectedFilter === 'pc' }"
			@click="setFilter('pc', 'Windows')"
		>
			<svgIcon icon-holder-class="icon-ext-windows" icon-id="icon-ext-windows" />
			<span class="filter-btn-text">{{ $t('navigation.platform.window') }}</span>
		</a>
		<a
			v-if="games.xbox.length > 0"
			class="games-filter-btn xbox"
			:class="{ active: selectedFilter === 'xbox' }"
			@click="setFilter('xbox', 'Xbox')"
		>
			<svgIcon icon-holder-class="icon-ext-xbox" icon-id="icon-ext-xbox" />
			<span class="filter-btn-text">{{ $t('navigation.platform.xbox') }}</span>
		</a>
		<a
			v-if="games.psn.length > 0"
			class="games-filter-btn psn"
			:class="{ active: selectedFilter === 'psn' }"
			@click="setFilter('psn', 'PSN')"
		>
			<svgIcon icon-holder-class="icon-psn" icon-id="icon-psn" />
			<span class="filter-btn-text">{{ $t('navigation.platform.psn') }}</span>
		</a>
		<a
			v-if="games.ios.length > 0"
			class="games-filter-btn apple"
			:class="{ active: selectedFilter === 'ios' }"
			@click="setFilter('ios', 'iOS')"
		>
			<svgIcon icon-holder-class="icon-apple" icon-id="icon-apple" />
			<span class="filter-btn-text">{{ $t('navigation.platform.apple') }}</span>
		</a>
		<a
			v-if="games.android.length > 0"
			class="games-filter-btn android"
			:class="{ active: selectedFilter === 'android' }"
			@click="setFilter('android', 'Android')"
		>
			<svgIcon icon-holder-class="icon-ext-android" icon-id="icon-ext-android" />
			<span class="filter-btn-text">{{ $t('navigation.platform.android') }}</span>
		</a>
	</div>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
export default {
	name: 'GameFilter',
	components: {
		svgIcon,
	},
	props: {
		selectedFilter: {
			type: String,
			default: '',
		},
		games: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {};
	},
	methods: {
		setFilter(filter, platform) {
			this.$emit('setFilter', filter);
			dataLayer.push({
				event: 'Games Filtered',
				gameFilterLocation: 'GNB',
				filterOption: platform,
			});
		},
	},
};
</script>

<style lang="less" scoped>
@import '~@arena/toolkit/src/less/toolkit/toolkit.less';
.games-filter-section {
	width: 100%;
	height: 77px;
	display: flex;
	align-items: center;
	justify-content: center;
	.games-filter-btn {
		width: 29px;
		height: 29px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 25px;
		opacity: 0.3;
		color: rgba(255, 255, 255, 1);
		border: solid 1px rgba(255, 255, 255, 1);
		margin: 3px;
		transition: opacity 0.2s ease;
		.filter-btn-text {
			display: none;
		}
		.icon-btn-all {
			width: 13px;
			height: 13px;
		}
		.icon-ext-windows {
			width: 12px;
			height: 13px;
		}
		.icon-ext-xbox {
			width: 15px;
			height: 15px;
		}
		.icon-psn {
			width: 17px;
			height: 17px;
		}
		.icon-apple {
			width: 13px;
			height: 16px;
			margin-bottom: 2px;
		}
		.icon-ext-android {
			width: 14px;
			height: 16px;
			margin-bottom: 1px;
		}
		&:hover {
			opacity: 1;
			cursor: pointer;
		}
		&:active {
			opacity: 0.5;
		}
		&.active {
			opacity: 1;
			border: solid 1px transparent;
			background-color: #0077ff;
			transition: all 0.2s ease;
			&:hover {
				background-color: #3093ff;
			}
			&:active {
				opacity: 0.5;
			}
		}
	}
}
@media (min-width: 1024px) {
	.games-filter-section {
		height: 88px;
		margin-bottom: -10px;
		.games-filter-btn {
			width: auto;
			padding: 0px 10px;
			margin: 5px;
			.filter-btn-text {
				display: block;
				margin-left: 6px;
			}
		}
	}
}
</style>
